var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendeesInActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11275",
    "data-name": "Path 11275",
    d: "M13.308,27.538V26.385a1.852,1.852,0,0,0,1.731-1.731V19.462c0-1.315-3.15-2.308-5.192-2.308s-5.192.992-5.192,2.308v5.192a1.852,1.852,0,0,0,1.731,1.731v1.154A2.994,2.994,0,0,1,3.5,24.654V19.462C3.5,17.044,7.7,16,9.846,16s6.346,1.044,6.346,3.462v5.192A2.994,2.994,0,0,1,13.308,27.538Z",
    transform: "translate(-1.481 -6.769)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11276",
    "data-name": "Path 11276",
    d: "M28.538,27.538V26.385c.721,0,1.731-.358,1.731-1.154V19.462c0-1.315-2.8-2.308-4.615-2.308H24.5V16h1.154c1.95,0,5.769,1.044,5.769,3.462v5.769C31.423,26.731,29.935,27.538,28.538,27.538Z",
    transform: "translate(-10.365 -6.769)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11277",
    "data-name": "Path 11277",
    d: "M12.383,9.922A2.787,2.787,0,0,1,9.5,7.037V5.883A2.787,2.787,0,0,1,12.383,3a2.787,2.787,0,0,1,2.885,2.885V7.037a2.787,2.787,0,0,1-2.885,2.885Zm0-5.769a1.638,1.638,0,0,0-1.731,1.731V7.037a1.638,1.638,0,0,0,1.731,1.731,1.638,1.638,0,0,0,1.731-1.731V5.883a1.638,1.638,0,0,0-1.731-1.731Z",
    transform: "translate(-4.018 -1.268)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3767",
    "data-name": "Rectangle 3767",
    width: 1.154,
    height: 14.423,
    transform: "translate(17.596 13.846)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3768",
    "data-name": "Rectangle 3768",
    width: 1.154,
    height: 14.423,
    transform: "translate(11.25 13.846)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3769",
    "data-name": "Rectangle 3769",
    width: 1.154,
    height: 14.423,
    transform: "translate(4.327 13.846)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3770",
    "data-name": "Rectangle 3770",
    width: 1.154,
    height: 8.654,
    transform: "translate(7.788 19.615)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11278",
    "data-name": "Path 11278",
    d: "M24.383,9.922A2.787,2.787,0,0,1,21.5,7.037V5.883a2.885,2.885,0,1,1,5.769,0V7.037a2.787,2.787,0,0,1-2.885,2.885Zm0-5.769a1.638,1.638,0,0,0-1.731,1.731V7.037a1.732,1.732,0,1,0,3.462,0V5.883a1.638,1.638,0,0,0-1.731-1.731Z",
    transform: "translate(-9.095 -1.268)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11279",
    "data-name": "Path 11279",
    d: "M40.538,27.538V26.385c.721,0,1.731-.358,1.731-1.154V19.462c0-1.315-2.8-2.308-4.615-2.308H36.5V16h1.154c1.95,0,5.769,1.044,5.769,3.462v5.769C43.423,26.731,41.935,27.538,40.538,27.538Z",
    transform: "translate(-15.442 -6.769)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3771",
    "data-name": "Rectangle 3771",
    width: 1.154,
    height: 14.423,
    transform: "translate(24.519 13.846)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11280",
    "data-name": "Path 11280",
    d: "M36.383,9.923A2.787,2.787,0,0,1,33.5,7.038V5.885a2.885,2.885,0,1,1,5.769,0V7.038a2.787,2.787,0,0,1-2.885,2.885Zm0-5.769a1.638,1.638,0,0,0-1.731,1.731V7.038a1.731,1.731,0,0,0,3.462,0V5.885a1.638,1.638,0,0,0-1.731-1.731Z",
    transform: "translate(-14.172 -1.269)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3772",
    "data-name": "Rectangle 3772",
    width: 30,
    height: 30,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendeesInActive);
export default __webpack_public_path__ + "static/media/attendees_inActive.fb2537112e1dbd3de1e9ca54fadabde3.svg";
export { ForwardRef as ReactComponent };